// extracted by mini-css-extract-plugin
export var avatar = "_i9-3";
export var avatarContainer = "_i9-2";
export var avatarSpacer = "_i9-5";
export var avatarSpacerContainer = "_i9-4";
export var avatarStackContainer = "_i9-1";
export var bubble = "_i9-0";
export var remainderBubble = "_i9-6";